import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { BLANK_ROUTE, RESET_PASSWORD_ROUTE } from '../../constants/app-url-constants';
import { AccountService } from '../shared/services/account.service';
import { UiService } from '../shared/services/ui.service';
import { AuthServerProvider } from './auth-jwt.service';
import { StateStorageService } from './state-storage.service';

@Injectable({ providedIn: 'root' })
export class UserRouteAccessService implements CanActivate {
  constructor(
    private router: Router,
    private accountService: AccountService,
    private stateStorageService: StateStorageService,
    private authServerProviderService: AuthServerProvider,
    private uiService: UiService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Promise<boolean> {
    return this.checkLogin(state.url);
  }

  checkLogin(url: string): Promise<boolean> {
    if (this.authServerProviderService.getUserRedirection() === 1) {
      this.router.navigate([RESET_PASSWORD_ROUTE]);
    }
    this.uiService.emitSpinnerSubject(true);
    return this.accountService
      .identity(true)
      .then(account => {
        if (account) {
          this.uiService.emitSpinnerSubject(false);
          return true;
        } else {
          this.stateStorageService.storeUrl(url);
          this.uiService.emitSpinnerSubject(false);
          this.router.navigate([BLANK_ROUTE]);
        }
        return false;
      })
      .catch(() => {
        this.uiService.emitSpinnerSubject(false);
        return false;
      });
  }
}
